module.exports = "/_next/static/images/ws-f4fea9307d16e07521a7948ecefcdb3a.svg";